import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class BuSelectionService extends BaseApiService {
    getBusinessUnits() {
        return this.get('Foundation/User/BusinessUnits/');
    }
    getWindows(businessUnitId: any) {
        return this.get('Foundation/User/Windows/' + businessUnitId);
    }
}
